import type { FieldId } from '~/evifields/src/types/FieldId';

export interface DocumentsSort {
  id: FieldId;
  desc: boolean;
}

/** The company default's shape; Pilot also returns the product default in it. */
export interface DocumentsTableSettings {
  columns: FieldId[];
  sort: DocumentsSort | null;
}

export type DocumentsPageSize = 10 | 20 | 30 | 50 | 100;

export const DOCUMENTS_PAGE_SIZES: DocumentsPageSize[] = [10, 20, 30, 50, 100];

/**
 * A person's table. A copy of the company's table has no `pageSize`, which
 * Pilot reads as 10.
 */
export interface PersonDocumentsTable extends DocumentsTableSettings {
  pageSize?: DocumentsPageSize;
}

// Pilot validates and repairs ids when Home reads the table through
// `home/documents/settings/`, so this only checks the shape.
export function parseDocumentsTable(
  value: unknown,
): PersonDocumentsTable | null {
  if (!value || typeof value !== 'object') return null;
  const { columns, sort, pageSize } = value as Partial<PersonDocumentsTable>;
  if (!Array.isArray(columns)) return null;
  return {
    columns,
    sort: sort ?? null,
    ...(pageSize && DOCUMENTS_PAGE_SIZES.includes(pageSize) && { pageSize }),
  };
}
